import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {AdminSupportButton} from '@freckle/educator-materials/ts/components/support-button/admin'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {link, supportButtonWrapper, menuLink} from './sidebar.module.scss'

const sidebarLinks = [
  {
    tabId: 'dashboard',
    name: 'Dashboard',
    route: Routes.dashboard(),
    dataTest: 'sidebar-teacher-link'
  },
  {
    tabId: 'growth',
    name: 'Growth Data',
    route: Routes.growth(),
    dataTest: 'sidebar-growth-link'
  },
  {
    tabId: 'usage',
    name: 'Usage Data',
    route: Routes.usage(),
    dataTest: 'sidebar-usage-link'
  },
  {
    tabId: 'proficiency-report',
    name: 'Proficiency Data',
    route: Routes.schoolProficiencyReport(),
    dataTest: 'sidebar-reports-link'
  },
  {
    tabId: 'assessments',
    name: 'School Assessments',
    route: Routes.assessments(),
    dataTest: 'sidebar-assessments-link'
  }
]

type Props = {
  tabId: string
  countryCode: string | null
}

export function Sidebar(props: Props) {
  const {tabId: activeTabId, countryCode} = props
  const {t} = useSafeTranslation()

  const sidebarLinksNode = sidebarLinks.map(({tabId, name, route, dataTest}) => {
    const activeClass = tabId === activeTabId ? 'active' : ''

    return (
      <li className={activeClass} key={tabId}>
        <Link href={route} className={link} dataTest={dataTest} reactRouter>
          <Text style="subtitle-2" className={menuLink}>
            {name}
          </Text>
        </Link>
      </li>
    )
  })

  return (
    <div className="sidebar hidden-print">
      <div className="sidebar-header">
        <Link href="/" reactRouter>
          <img
            src={`${PATHS.imageAssetsUrl}/company-logos/renaissance-freckle-logo-white.svg`}
            alt={t('SIDEBAR_LINK_LOGO_ALT')}
            title={t('SIDEBAR_LINK_LOGO_TITLE')}
            className="freckle-logo"
          />
        </Link>
      </div>
      <div className="sidebar-links">
        <ul className="list-unstyled">{sidebarLinksNode}</ul>
      </div>
      <div className={supportButtonWrapper}>
        <AdminSupportButton countryCode={countryCode} />
      </div>
    </div>
  )
}
